import type { Locale } from "../Locale.js";

export function getAlgoliaIndexName(locale: Locale, pricingLevelSecretKey: string): string {
	return `${locale}_${pricingLevelSecretKey}`;
}
